import {
  forwardRef,
  ReactNode,
  HTMLAttributes,
  useContext,
  useEffect,
  useId,
} from "react";
import { ModalTitleContext } from "./ModalTitleContext";

interface IModalTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  className?: string;
  children: ReactNode;
}

// Forwarding ref to ensure this component can hold a ref
const ModalTitle = forwardRef<HTMLHeadingElement, IModalTitleProps>(
  ({ className, children, ...rest }, ref) => {
    const generatedId = useId();
    const id = rest.id ?? generatedId;
    const registerTitle = useContext(ModalTitleContext);

    useEffect(() => {
      registerTitle?.(id);
      return () => registerTitle?.(undefined);
    }, [id, registerTitle]);

    return (
      <h1 ref={ref} className={`modal-title ${className}`} {...rest} id={id}>
        {children}
      </h1>
    );
  },
);

export { ModalTitle };
